import { render } from "./error-404.vue?vue&type=template&id=01b9c987&ts=true"
import script from "./error-404.vue?vue&type=script&lang=ts"
export * from "./error-404.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__